module.exports = __webpack_public_path__ + "static/cateau1-d566388c0d69d66385b68448c8a286e1.png";